<template>
    <Button :label="$t('mark_complete')" icon="pi pi-check" class="p-button-success p-button-sm mr-1" v-if="canMarkComplete" @click="onShowModal" />
    <Button :label="$t('unmark_complete')" icon="pi pi-backward" class="p-button-warning p-button-sm mr-1" v-if="canUnmarkComplete" @click="onShowModal" />

    <CustomSidebar v-model:visible="showModal" position="bottom" :dismissable="false" :title="canMarkComplete ? $t('mark_complete') : $t('unmark_complete')" class="p-1" :blocked="blocked">
        <template #actions>
            <Button icon="pi pi-check" class="p-button-sm p-button-success mr-1" :label="$t('mark_complete')" v-if="canMarkComplete" @click="onMarkComplete"></Button>
            <Button icon="pi pi-backward" class="p-button-sm p-button-warning mr-1" :label="$t('unmark_complete')" v-if="canUnmarkComplete" @click="onUnmarkComplete"></Button>
        </template>

        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-4 md-4 p-fluid">
                <ScrollPanel style="width:100%;height:80vh">
                    <ModalData :data="orderData" v-if="orderData"/>
                </ScrollPanel>
            </div>
            <Divider layout="vertical" />
            <div class="col-8 md-4 p-fluid">
                <ScrollPanel style="width:100%;height: 80vh">
                    <DataTable :loading="!orderData" :value="orderData ? orderData.Details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                        <Column field="Item_No" header="Item No" key="Item_No" style="width:10%">  
                        </Column>
                        <Column field="Material_Name" header="Material" key="Material_Name">
                        </Column>
                        <Column field="Qty" :header="$t('qty')" key="Remarks" style="width:15%">
                            <template #body="slotProps">
                                <div class="p-fluid">
                                    <!-- <InputText v-model="slotProps.data[slotProps.column.props.field]" /> -->
                                    <InputNumber v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" :minFractionDigits="1" :maxFractionDigits="3" :disabled="true" />
                                </div>
                            </template>
                        </Column>
                        <Column field="os_qty" :header="$t('os_qty')" key="Remarks" style="width:15%">
                            <template #body="slotProps">
                                <div class="p-fluid">
                                    <!-- <InputText v-model="slotProps.data[slotProps.column.props.field]" /> -->
                                    <InputNumber v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" :minFractionDigits="1" :maxFractionDigits="3" :disabled="true" />
                                </div>
                            </template>
                        </Column>
                        <Column field="real_qty" :header="$t('real_qty')" key="Remarks" style="width:15%">
                            <template #body="slotProps">
                                <div class="p-fluid">
                                    <!-- <InputText v-model="slotProps.data[slotProps.column.props.field]" /> -->
                                    <InputNumber v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" :minFractionDigits="1" :maxFractionDigits="3" :disabled="true" />
                                </div>
                            </template>
                        </Column>
                        <Column field="UOM" header="UOM" key="Active" style="width:10%">
                        </Column>
                    </DataTable>

                    <Divider />

                    <div class="p-inputtext-sm">
                        
                    </div>
                </ScrollPanel>
            </div>
        </div>
    </CustomSidebar> 
</template>
<script>

import ModalData from '../Helper/_ModalData.vue'

export default {
    components: {
        'ModalData': ModalData,
    },
    emits: ['message'],
    props:{
        data: {
            type: Object,
            default: null
        },
        canMarkComplete:{
            type: Boolean,
            default: false,
        },
        canUnmarkComplete:{
            type:Boolean,
            default: false
        }
    },
    data(){
        return{
            showModal: false,
            orderData: null,
            dataUrl: "order/",
            blocked:false,
        }
    },
    methods: {
        reset(){
            this.orderData = null;
        },
        onShowModal(){
            this.reset();

            this.orderData = null;
            this.assignModel = null;
           
            this.blocked = true;
            this.showModal = true;

            var self = this;

            this.$axios.get(this.$API_URL + this.dataUrl + this.data[0].Id + "/" + this.$FORM_MODE_EDIT)
                .then((response) => {
                    if (response.data.success) {
                        self.orderData = response.data.data.header;
                    }
                    else {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        self.showModal = false;
                    }
                    self.blocked = false;
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                    self.blocked = false;
                    self.showModal = false;
                });

        },
        onMarkComplete(){
                var self = this;

                this.blocked = true;

                this.$axios.put(this.$API_URL + this.dataUrl + "mark_complete/" + this.data[0].Id)
                    .then((response) => {
                        if (response.data.success) {
                            self.showModal = false;
                            self.$parent.$toast.add({ severity: 'success', summary: "Data Saved", detail: response.data.message, life: 120000 });
                            self.$emit('close');
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }

                        self.blocked = false;
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });
            },
            onUnmarkComplete(){
                var self = this;

                this.blocked = true;

                this.$axios.put(this.$API_URL + this.dataUrl + "unmark_complete/" + this.data[0].Id)
                    .then((response) => {
                        if (response.data.success) {
                            self.showModal = false;
                            self.$parent.$toast.add({ severity: 'success', summary: "Data Saved", detail: response.data.message, life: 120000 });
                            self.$emit('close');
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }

                        self.blocked = false;
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });
            },
    }
}
</script>